import React, { useState } from "react";
import {
  Box,
  Typography,
  Button,
  Container,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Pagination,
} from "@mui/material";
import { Link } from "react-router-dom";
import { SquarePen, Trash, Eye } from "lucide-react"; // Import the Eye icon
import { useSelector } from "react-redux";
import { Spin } from "antd"; // Import Modal from antd
import { useListing } from "../../contexts/ListingContext";

function Listings() {
  const user = useSelector((state) => state.user.user);

  const {
    listings,
    handleDeleteListing,
    isLoading,
    setPage,
    totalPages
  } = useListing();

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        position: 'relative'
      }}
    >
      <img style={{
        width: '100%',
        objectFit: 'contain',
        position: 'fixed',
        zIndex: -1
      }} src="https://cdn.prod.website-files.com/65f03c978efea1c906592c94/65f41d5f2ba41fbbe6c5514c_AdobeStock_546815906_gruen_klein_bearbeitet_002.webp" />
      <Container>
        <Typography
          variant="h4"
          component="h1"
          gutterBottom
          sx={{
            fontWeight: "bold",
            color: "#0BD349",
            paddingTop: "5px",
          }}
        >
          {/* Listings */}
          Einträge
        </Typography>
        {
          !!user?.userData.active && (
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                paddingBottom: "16px",
              }}
            >
              <Link to={user?.userData.active ? "/dashboard/new-listing" : '#'}>
                <Button
                  variant="contained"
                  sx={{
                    backgroundColor: "#fff",
                    color: "#333",
                    padding: "12px 24px",
                    fontSize: "16px",
                    borderRadius: "8px",
                    "&:hover": {
                      backgroundColor: "#098B2B",
                      // color: "#fff",
                    },
                    // border: '1px solid #eee',
                  }}
                >
                  {/* Add New Listing */}
                  Neuen Eintrag hinzufügen
                </Button>
              </Link>
            </Box>
          )
        }
        <TableContainer component={Paper} sx={{ marginBottom: 3, backgroundColor: 'rgb(28, 28, 28, 0.9)' }}>
          <Table>
            <TableHead >
              <TableRow>
                <TableCell style={{
                  backgroundColor: 'rgb(0, 0, 0, 0.6)',
                  color: '#0BD349'
                }} sx={{ fontWeight: "bold" }}>
                  Sr no.
                </TableCell>
                <TableCell style={{
                  backgroundColor: 'rgb(0, 0, 0, 0.6)',
                  color: '#0BD349'
                }} sx={{ fontWeight: "bold" }}>
                  {/* Listing Title */}
                  Titel des Eintrags
                </TableCell>
                <TableCell style={{
                  backgroundColor: 'rgb(0, 0, 0, 0.6)',
                  color: '#0BD349'
                }} sx={{ fontWeight: "bold" }}>
                  {/* Company Name */}
                  Name der Firma
                </TableCell>
                <TableCell style={{
                  backgroundColor: 'rgb(0, 0, 0, 0.6)',
                  color: '#0BD349'
                }} sx={{ fontWeight: "bold" }}>
                  {/* Categories */}
                  Kategorien
                </TableCell>
                <TableCell style={{
                  backgroundColor: 'rgb(0, 0, 0, 0.6)',
                  color: '#0BD349'
                }} sx={{ fontWeight: "bold" }}>
                  {/* Hall number */}
                  Hallennummer
                </TableCell>

                {/* Listing Description */}
                {/* <TableCell style={{
                  backgroundColor: 'rgb(0, 0, 0, 0.6)',
                  color: '#0BD349'
                }} sx={{ fontWeight: "bold" }}>
                  Beschreibung des Eintrags
                </TableCell> */}

                <TableCell style={{
                  backgroundColor: 'rgb(0, 0, 0, 0.6)',
                  color: '#0BD349'
                }} sx={{ fontWeight: "bold" }}>
                  {/* Listing Image */}
                  Bild auflisten
                </TableCell>
                <TableCell style={{
                  backgroundColor: 'rgb(0, 0, 0, 0.6)',
                  color: '#0BD349'
                }} sx={{ fontWeight: "bold" }}>
                  {/* Actions */}
                  Aktionen
                </TableCell>
              </TableRow>
            </TableHead>
            {
              isLoading && (
                <TableCell colSpan={6}>
                  <div style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    width: '100%',
                  }}>
                    <Spin tip="Loading..." />
                  </div>
                </TableCell>
              )
            }
            <TableBody>
              {listings.map((listing, index) => (
                <TableRow key={listing.id}>
                  <TableCell>{index + 1}</TableCell>
                  <TableCell>{listing.listing_title}</TableCell>
                  <TableCell>{listing.companyName}</TableCell>
                  <TableCell>{listing.category_names || 'No categories'}</TableCell>
                  <TableCell>{listing.hallNo || 'N/A'}</TableCell>
                  {/* <TableCell dangerouslySetInnerHTML={{
                    __html: listing.listing_description
                  }} style={{ maxWidth: '250px' }} /> */}
                  <TableCell>
                    <Link
                      className="link"
                      to={listing.company_website.startsWith('http') ? listing.company_website : `https://${listing.company_website}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        src={listing.listing_image}
                        alt={listing.listing_title}
                        style={{
                          width: "80px",
                          height: "auto",
                          borderRadius: "6px",
                        }}
                      />
                    </Link>
                  </TableCell>
                  <TableCell>
                    <Link target="_blank" className="link" to={`https://www.ennovation-austria.com/single-product-page?listingId=${listing.id}`}>
                      <Eye size={20} strokeWidth={1.5} style={{ marginRight: '10px' }} />
                    </Link>
                    <Link className="link" to={`/dashboard/edit-listing/${listing.id}`}>
                      <SquarePen size={20} strokeWidth={1.5} />
                    </Link>
                    <Link className="link" onClick={() => handleDeleteListing(listing.id)}>
                      <Trash size={20} strokeWidth={1.5} style={{ marginLeft: '10px' }} />
                    </Link>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            margin: '1.25rem',
          }}>
            <Pagination
              onChange={(ev, page) => setPage(page)}
              count={totalPages}
              color="standard"
            />
          </div>
        </TableContainer>
      </Container>
    </Box>
  );
}

export default Listings;